import type { TReduxAction } from '../actions'
import {
    common_CLEAR_DATA,
    common_COORDINATES_INVALIDATE,
    common_COORDINATES_SET,
    common_SET_CURRENTLY_SYNCING,
    common_SET_LAST_SYNC_TIME,
} from '../actions/common'

export type TCommonState = {
    currentlySyncing: boolean
    lastSyncTime: number
    lat: number
    lon: number
}

const initialState: TCommonState = {
    currentlySyncing: false,
    lastSyncTime: 0,
    lat: null,
    lon: null,
}

export function commonReducer(state: TCommonState = initialState, action: TReduxAction): TCommonState {
    switch (action.type) {
        case common_SET_CURRENTLY_SYNCING:
            return {
                ...state,
                currentlySyncing: action.syncing,
            }
        case common_SET_LAST_SYNC_TIME:
            return {
                ...state,
                lastSyncTime: action.time,
            }
        case common_COORDINATES_SET:
            return {
                ...state,
                lat: action.lat,
                lon: action.lon,
            }
        case common_COORDINATES_INVALIDATE:
            return {
                ...state,
                lat: null,
                lon: null,
            }
        case common_CLEAR_DATA:
            return {
                ...initialState,
                lat: state.lat,
                lon: state.lon,
            }
        default:
            return state
    }
}

export function getCoordinates(state: TCommonState) {
    const { lat, lon } = state
    return { lat, lon }
}
